import { useNavigate } from 'react-router-dom';
import {
  Box, Card, List, ListItemButton, ListItemIcon, ListItemText, Switch, Typography, Divider,
} from '@mui/material';
import PersonRounded from '@mui/icons-material/PersonRounded';
import DarkModeRounded from '@mui/icons-material/DarkModeRounded';
import FolderSpecialRounded from '@mui/icons-material/FolderSpecialRounded';
import PeopleAltRounded from '@mui/icons-material/PeopleAltRounded';
import FlagRounded from '@mui/icons-material/FlagRounded';
import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import ReceiptLongRounded from '@mui/icons-material/ReceiptLongRounded';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';
import PageHeader from '../components/ui/PageHeader';
import { useThemeMode } from '../theme/ThemeModeContext';
import { clearAuthSession } from '../utils/auth';

const MANAGE_LINKS = [
  { label: 'Projects', path: '/manage/projects', icon: FolderSpecialRounded },
  { label: 'Assignee Names', path: '/manage/assignees', icon: PeopleAltRounded },
  { label: 'Statuses', path: '/manage/statuses', icon: FlagRounded },
  { label: 'Payment Types', path: '/manage/payment-types', icon: PaymentsRounded },
  { label: 'Expenses', path: '/manage/expensees', icon: ReceiptLongRounded },
];

const SettingsPage = () => {
  const navigate = useNavigate();
  const { mode, toggleMode } = useThemeMode();

  const handleLogout = () => {
    clearAuthSession();
    navigate('/login');
  };

  return (
    <Box sx={{ maxWidth: 640 }}>
      <PageHeader title="Settings" />

      <Card sx={{ mb: 2.5, p: 1 }}>
        <Typography variant="subtitle2" sx={{ px: 2, pt: 1, fontWeight: 700, color: 'text.secondary' }}>Profile</Typography>
        <List disablePadding>
          <ListItemButton onClick={() => navigate('/profile')}>
            <ListItemIcon><PersonRounded /></ListItemIcon>
            <ListItemText primary="My Profile" secondary="View and edit your account details" />
            <ChevronRightRounded sx={{ color: 'text.disabled' }} />
          </ListItemButton>
        </List>
      </Card>

      <Card sx={{ mb: 2.5, p: 1 }}>
        <Typography variant="subtitle2" sx={{ px: 2, pt: 1, fontWeight: 700, color: 'text.secondary' }}>Appearance</Typography>
        <List disablePadding>
          <ListItemButton onClick={toggleMode} disableRipple sx={{ cursor: 'default' }}>
            <ListItemIcon><DarkModeRounded /></ListItemIcon>
            <ListItemText primary="Dark mode" secondary={mode === 'dark' ? 'On' : 'Off'} />
            <Switch checked={mode === 'dark'} onChange={toggleMode} onClick={(e) => e.stopPropagation()} />
          </ListItemButton>
        </List>
      </Card>

      <Card sx={{ mb: 2.5, p: 1 }}>
        <Typography variant="subtitle2" sx={{ px: 2, pt: 1, fontWeight: 700, color: 'text.secondary' }}>Manage</Typography>
        <List disablePadding>
          {MANAGE_LINKS.map(({ label, path, icon: Icon }) => (
            <ListItemButton key={path} onClick={() => navigate(path)}>
              <ListItemIcon><Icon /></ListItemIcon>
              <ListItemText primary={label} />
              <ChevronRightRounded sx={{ color: 'text.disabled' }} />
            </ListItemButton>
          ))}
        </List>
      </Card>

      <Card sx={{ p: 1 }}>
        <List disablePadding>
          <Divider />
          <ListItemButton onClick={handleLogout} sx={{ color: 'error.main' }}>
            <ListItemIcon sx={{ color: 'error.main' }}><LogoutRounded /></ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </Card>
    </Box>
  );
};

export default SettingsPage;
